/**
 * Restreint la route aux environnements de développement (import.meta.dev).
 * En build de production, redirection vers l’accueil.
 */
export default defineNuxtRouteMiddleware(() => {
  if (import.meta.dev) {
    return
  }
  return navigateTo('/')
})
